import PenerimaanSuratJalan from './PenerimaanSuratJalan';

export default PenerimaanSuratJalan;
